import { Check } from "lucide-react";
import FeatureVisual from "./FeatureVisual";

export default function FeatureSection({ group, index, page }) {
  const Icon = group.icon;
  const imageFirst = index % 2 === 1;

  return (
    <section id={group.id} className="scroll-mt-24 border-t border-slate-200 py-14 sm:py-20">
      <div className="grid items-center gap-9 lg:grid-cols-12 lg:gap-14">
        <div className={`${group.image ? "lg:col-span-5" : "lg:col-span-12 max-w-3xl"} ${imageFirst && group.image ? "lg:order-2" : ""}`}>
          <div className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.18em] text-emerald-800">
            <span className="grid h-9 w-9 place-items-center rounded-full bg-emerald-100 text-emerald-800">
              <Icon className="h-4 w-4" aria-hidden="true" />
            </span>
            {group.eyebrow}
          </div>
          <h2 className="mt-4 font-display text-3xl font-bold tracking-tight text-slate-950 sm:text-4xl">{group.title}</h2>
          <p className="mt-4 text-base leading-7 text-slate-600">{group.description}</p>
          <ul className="mt-6 space-y-3">
            {group.benefits.map((benefit) => (
              <li key={benefit} className="flex items-start gap-3 text-sm leading-6 text-slate-700">
                <Check className="mt-1 h-4 w-4 shrink-0 text-emerald-700" aria-hidden="true" />
                <span>{benefit}</span>
              </li>
            ))}
          </ul>
        </div>
        {group.image && (
          <div className={`min-w-0 lg:col-span-7 ${imageFirst ? "lg:order-1" : ""}`}>
            <FeatureVisual
              image={group.image}
              alt={group.alt}
              caption={group.caption}
              page={page}
              featureId={group.id}
              priority={index === 0}
            />
          </div>
        )}
      </div>
    </section>
  );
}
